import React from "react";

import cx from "classnames";

import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import AuthDropDown from "./AuthDropDown";

import { createUseStyles } from "react-jss";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

// @mui/icons-material
import Menu from "@mui/icons-material/Menu";
import { IconButton, Button, SwipeableDrawer } from "@mui/material";

import Heading from "components/Navigation/Navbars/Auth/Heading";
import { IsMedium } from "components/Responsive/Responsive.js";

import styles from "assets/jss/material-dashboard-pro-react/components/navbar/auth/authNavbarStyle.js";
import CustomAvatar from "components/User/Avatar";

const useStyles = createUseStyles(styles);

import { useTheme, useMediaQuery } from "@mui/material";

export default function AuthNavbar(props) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isMedium = IsMedium();
  const classes = useStyles();
  const { shrinkOnValue } = props;
  const [hasScrolledDown, setHasScrolledDown] = React.useState(false);
  const [openMobileMenu, setOpenMobileMenu] = React.useState(false);

  React.useEffect(() => {
    function resizeHeaderOnScroll() {
      const distanceY =
          window.pageYOffset || document.documentElement.scrollTop,
        shrinkOn = shrinkOnValue;

      if (distanceY > shrinkOn) {
        setHasScrolledDown(true);
      } else {
        setHasScrolledDown(false);
      }
    }

    window.addEventListener("scroll", resizeHeaderOnScroll);

    return () => {
      window.removeEventListener("scroll", resizeHeaderOnScroll);
    };
  }, [shrinkOnValue]);

  // verifies if routeName is the one active (in browser input)
  //const activeRoute = (routeName) => {
  //  return window.location.href.indexOf(routeName) > -1 ? true : false;
  //};

  const handleMobileMenu = () => {
    setOpenMobileMenu(!openMobileMenu);
  };

  var navList = (
    <>
      <ListItem className={classes.listItem}>
        <Button
          classes={{ root: classes.listButton }}
          component={Link}
          to="/"
          color="secondary"
        >
          Home
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          classes={{ root: classes.listButton }}
          component={Link}
          to="/plans"
          color="secondary"
        >
          Plans
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          classes={{ root: classes.listButton }}
          component={Link}
          to="/journal"
          color="secondary"
        >
          Journal
        </Button>
      </ListItem>
      {(isMobile) ? (
        <>
          <ListItem className={classes.listItem}>
            <Button
              classes={{ root: classes.listButton }}
              component={Link}
              to="/about"
              color="secondary"
            >
              About
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              classes={{ root: classes.listButton }}
              component={Link}
              to="/contact-us"
              color="secondary"
            >
              Contact us
            </Button>
          </ListItem>
        </>
      ) : (
        <AuthDropDown classes={classes}/>
      )}
      <ListItem className={classes.listItem}>
        <Button
          classes={{ root: classes.listButton }}
          component={Link}
          to="/admin/project"
          color="secondary"
        >
          Go to dashboard
        </Button>
      </ListItem>
    </>
  );

  const list =
    classes.list +
    " " +
    cx({
      [classes.alignItems]: hasScrolledDown,
    });

  if (isMedium) {
    return (
      <AppBar
        position="static"
        className={classes.appBar + " " + classes.moveableAppBar}
      >
        <Toolbar className={classes.containerSmaller}>
          <Heading isMobile={isMedium} />

          <IconButton
            className={classes.menuBtn}
            onClick={handleMobileMenu}
            size="large"
          >
            <Menu className={classes.menuIcon} />
          </IconButton>

          <SwipeableDrawer
            anchor="top"
            open={openMobileMenu}
            onClose={handleMobileMenu}
          >
            <div
              className={classes.mobileDrawer}
              onClick={handleMobileMenu}
              onKeyDown={handleMobileMenu}
            >
              <div className={classes.mobileDrawerContent}>{navList}</div>
            </div>
          </SwipeableDrawer>

          <CustomAvatar buttonClasses={classes.listButton} />
        </Toolbar>
      </AppBar>
    );
  } else {
    return (
      <AppBar
        position="static"
        className={classes.appBar + " " + classes.moveableAppBar}
      >
        <Toolbar className={classes.containerSmaller}>
          <Heading hasScrolledDown={hasScrolledDown} />

          <List className={list}>
            {navList}
            <ListItem className={classes.listItem}>
              <CustomAvatar buttonClasses={classes.listButton} />
            </ListItem>
          </List>
        </Toolbar>
      </AppBar>
    );
  }
}

AuthNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  shrinkOnValue: PropTypes.number,
};
